import React, { useEffect, useState } from 'react';
import Empty from '../../Empty.jsx';
import { CloseIcon } from '../../icons/CloseIcon.jsx';
import AuthorizedAction from '../../AuthorizedAction.js';
import StakeholderSearchSelect from '../../StakeholderSearchSelect.jsx';
import styles from './OrgGroupStakeholdersBulkSelect.module.css';

function OrgGroupStakeholdersBulkSelect(props) {
  const {
    orgStakeholders,
    selectedGroupStakeholders,
    updateSelectedGroupStakeholders,
    onShowModal,
    additionalFields,
    customClass,
    handleRemove,
  } = props;

  const [filteredStakeholders, setFilteredStakeholders] = useState(null);

  const isActive = (id) =>
    !!selectedGroupStakeholders.find(
      (orgStakeholder) => orgStakeholder.id === id
    );

  const handleSelect = (stakeholder) => {
    updateSelectedGroupStakeholders([
      ...selectedGroupStakeholders,
      { id: stakeholder.id, name: stakeholder.fullName, ...additionalFields },
    ]);
  };

  const handleStakeholderSelect = (stakeholder) => {
    const isCurrentlySelected = isActive(stakeholder.id);
    if (isCurrentlySelected) {
      handleRemove(stakeholder.id);
    } else {
      handleSelect(stakeholder);
    }
  };

  const renderGroupItem = (orgStakeholder) => {
    const name = orgStakeholder ? orgStakeholder.name : '';

    return (
      <div key={orgStakeholder.id} className="flex m-t-4 m-l-4 item-style">
        {orgStakeholder.archived ? `${name || ''} (archived)` : name}
        <span
          className="btn btn-clear close-btn"
          onClick={() => handleRemove(orgStakeholder.id)}
        >
          <CloseIcon />
        </span>
      </div>
    );
  };

  useEffect(() => {
    setFilteredStakeholders(
      orgStakeholders.filter((item) => item.objectType === 'group')
    );
  }, [orgStakeholders]);

  // Convert selectedGroupStakeholders array to object for StakeholderSearchSelect
  const selectedStakeholdersObj = selectedGroupStakeholders.reduce(
    (acc, stakeholder) => {
      acc[stakeholder.id] = true;
      return acc;
    },
    {}
  );

  return filteredStakeholders ? (
    <div
      className={`${styles.orgStakeholdersBulkSelect} m-b-24 ${customClass}`}
    >
      <div className="bulk-select m-b-12">
        <div className="flex flex-align-start flex-wrap">
          {selectedGroupStakeholders.map(renderGroupItem)}
        </div>
        <StakeholderSearchSelect
          stakeholders={filteredStakeholders}
          selectedStakeholders={selectedStakeholdersObj}
          onSelectStakeholder={handleStakeholderSelect}
          title="Select Stakeholder(s)"
          showArchived
          style={{ padding: '8px 15px', width: '100%' }}
          className="dropdown-toggle btn btn-info btn-clear btn-no-left-border"
        />
      </div>
      {onShowModal ? (
        <AuthorizedAction action="create" subject="organizationStakeholder">
          <button
            type="button"
            className="btn-clear btn-link"
            onClick={(event) =>
              onShowModal(selectedGroupStakeholders.length, 'group')
            }
          >
            {' '}
            + Add Group Stakeholder
          </button>
        </AuthorizedAction>
      ) : null}
    </div>
  ) : (
    <Empty simplified />
  );
}

export default OrgGroupStakeholdersBulkSelect;
